import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const NotAuthorizedPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/');
    }, 7000);
    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div style={{ textAlign: 'center', marginTop: '10px' }}>
      <h1>403 - You Are Not Authorized</h1>
      <p>You do not have permission to access this page.</p>
      <p>Redirecting to the home page in 7 seconds...</p>
    </div>
  );
};

export default NotAuthorizedPage;